/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type TrackBackofficeMetricMutationVariables = Types.Exact<{
  input: Types.BackofficeMetricInput
}>

export type TrackBackofficeMetricMutation = {
  __typename?: 'Mutation'
  trackBackofficeMetric: boolean
}

export const TrackBackofficeMetricDocument = gql`
    mutation trackBackofficeMetric($input: BackofficeMetricInput!) {
  trackBackofficeMetric(input: $input)
}
    `
export type TrackBackofficeMetricMutationFn = Apollo.MutationFunction<
  TrackBackofficeMetricMutation,
  TrackBackofficeMetricMutationVariables
>

/**
 * __useTrackBackofficeMetricMutation__
 *
 * To run a mutation, you first call `useTrackBackofficeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackBackofficeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackBackofficeMetricMutation, { data, loading, error }] = useTrackBackofficeMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackBackofficeMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackBackofficeMetricMutation,
    TrackBackofficeMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TrackBackofficeMetricMutation,
    TrackBackofficeMetricMutationVariables
  >(TrackBackofficeMetricDocument, options)
}
export type TrackBackofficeMetricMutationHookResult = ReturnType<
  typeof useTrackBackofficeMetricMutation
>
export type TrackBackofficeMetricMutationResult =
  Apollo.MutationResult<TrackBackofficeMetricMutation>
export type TrackBackofficeMetricMutationOptions = Apollo.BaseMutationOptions<
  TrackBackofficeMetricMutation,
  TrackBackofficeMetricMutationVariables
>
